/* RESPONSIBLE TEAM: team-tickets-1 */
import StepSerializer from '../step';

export default StepSerializer;
